"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AgendaCell;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function AgendaCell(_ref) {
  var cell = _ref.cell,
    _ref$uriTransformer = _ref.uriTransformer,
    uriTransformer = _ref$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref$uriTransformer,
    intl = _ref.intl,
    defaultLanguage = _ref.defaultLanguage,
    project = _ref.project,
    logEvent = _ref.logEvent;
  var _ref2 = (0, _react.useState)(null),
    _ref3 = _slicedToArray(_ref2, 2),
    selectedDay = _ref3[0],
    setSelectedDay = _ref3[1];
  var _ref4 = (0, _react.useState)(cell.categories.length > 0 ? cell.categories[0].id : null),
    _ref5 = _slicedToArray(_ref4, 2),
    selectedCategory = _ref5[0],
    setSelectedCategory = _ref5[1];
  var _ref6 = (0, _react.useState)(null),
    _ref7 = _slicedToArray(_ref6, 2),
    curentEvent = _ref7[0],
    setCurrentEvent = _ref7[1];
  var _ref8 = (0, _react.useState)(1),
    _ref9 = _slicedToArray(_ref8, 2),
    marginLeft = _ref9[0],
    setMarginLeft = _ref9[1];
  var _ref0 = (0, _react.useState)(cell.days.sort(function (a, b) {
      return new Date(a.date) - new Date(b.date);
    })),
    _ref1 = _slicedToArray(_ref0, 2),
    days = _ref1[0],
    setDays = _ref1[1];
  var _ref10 = (0, _react.useState)(cell.events),
    _ref11 = _slicedToArray(_ref10, 2),
    events = _ref11[0],
    setEvents = _ref11[1];
  var animation = function animation() {
    setMarginLeft(0);
    setTimeout(function () {
      setMarginLeft(1);
    }, 200);
  };
  (0, _react.useEffect)(function () {
    var _iterator = _createForOfIteratorHelper(days),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _day = _step.value;
        if (new Date(_day.date).getDate() == new Date().getDate()) {
          setSelectedDay(_day.id);
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (!selectedDay) {
      var _iterator2 = _createForOfIteratorHelper(days),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var day = _step2.value;
          if (new Date(day.date) > new Date()) {
            setSelectedDay(day.id);
            return;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, [days]);
  (0, _react.useEffect)(function () {
    setDays(cell.days.sort(function (a, b) {
      return new Date(a.date) - new Date(b.date);
    }));
    setEvents(cell.events.sort(function (a, b) {
      return new Date(a.start) - new Date(b.start);
    }));
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: '2%',
      height: '100%',
      width: '96.5%',
      backgroundColor: cell.background_color,
      fontFamily: project ? project.default_button_font : 'initial',
      overflowX: 'scroll',
      overflowY: 'scroll',
      overflow: 'scroll',
      color: cell.text_color
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: '0.15em',
      width: '96%',
      backgroundColor: cell.background_color_filter_category,
      borderRadius: '1.88em',
      position: 'absolute',
      left: '2%'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      overflowX: 'visible',
      overflowY: 'hidden',
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start'
    }
  }, cell.categories.map(function (category) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: category.id,
      style: {
        padding: '0.05em',
        flex: 1,
        overflow: 'visible'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        background: selectedCategory === category.id ? cell.background_color_filter_category_checked : 'rgba(0, 0, 0, 0)',
        padding: '0.5em',
        transitionDuration: '200ms',
        fontSize: cell.font_size_filter_category + 'em',
        borderRadius: cell.bolder_radius_filter__category ? cell.font_size_filter_category + 0.5 + 'em' : '0em',
        color: selectedCategory === category.id ? cell.text_color_category_filter_selected : cell.text_color_category_filter,
        textAlign: 'center',
        fontWeight: 'bold',
        boxShadow: selectedCategory === category.id ? '0px 0px 0.15em 0.15em rgba(0,0,0,0.3)' : 'none'
      },
      onClick: function onClick() {
        if (category.id === selectedCategory) {
          return null;
        }
        logEvent('click', {
          cellId: cell.id,
          pageId: cell.page_id,
          languageCode: intl ? intl.locale : null,
          category_selected: category.name
        });
        animation();
        setTimeout(function () {
          setSelectedCategory(category.id);
        }, 200);
      }
    }, (0, _utils.i18nData)(category, 'name', intl, defaultLanguage)));
  })))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      backgroundColor: cell.background_color_filter_day,
      padding: '0.15em',
      marginTop: '4.4em',
      borderRadius: (cell.font_size_filter_day + 0.5) / 2 + 'em'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: '0.15em',
      width: '97.6%',
      backgroundColor: cell.background_color_filter_day,
      borderRadius: '0.5em'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
  }, days.map(function (day) {
    if (new Date(day.date).getDate() < new Date().getDate()) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      key: day.id,
      style: {
        padding: '0em'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        transitionDuration: '200ms',
        padding: '0.25em',
        fontSize: cell.font_size_filter_day + 'em',
        color: selectedDay === day.id ? cell.text_color_day_filter_selected : cell.text_color_day_filter,
        background: selectedDay === day.id ? cell.background_color_filter_day_checked : 'rgba(0, 0, 0, 0)',
        borderTopLeftRadius: cell.bolder_radius_filter_day ? cell.font_size_filter_day / 2 + 0.5 + 'em' : '0em',
        borderTopRightRadius: cell.bolder_radius_filter_day ? cell.font_size_filter_day / 2 + 0.5 + 'em' : '0em',
        textAlign: 'center'
      },
      onClick: function onClick() {
        if (selectedDay === day.id) {
          return null;
        }
        logEvent('click', {
          cellId: cell.id,
          pageId: cell.page_id,
          languageCode: intl ? intl.locale : null,
          day_selected: new Date(day.date).toLocaleDateString(intl ? intl.locale : 'fr', {
            month: 'short',
            day: '2-digit'
          })
        });
        animation();
        setTimeout(function () {
          setSelectedDay(day.id);
        }, 200);
      }
    }, intl ? new Date(day.date).toLocaleDateString(intl.locale, {
      month: 'short',
      day: '2-digit'
    }).split(' ').map(function (elem) {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontWeight: 'bold'
        },
        key: elem
      }, elem.toUpperCase());
    }) : 'Date...'));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      backgroundColor: cell.background_color,
      color: cell.text_color,
      overflowY: 'scroll',
      overflowX: 'hidden',
      padding: '0em',
      height: '70vh',
      borderBottomRightRadius: '0.5em',
      borderBottomLeftRadius: '0.5em'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      opacity: marginLeft,
      position: 'absolute',
      height: '70vh',
      transitionDuration: '200ms',
      overflowY: 'scroll',
      width: '100%',
      overflowX: 'hidden'
    }
  }, events.map(function (event) {
    if (event.agenda_day_id !== selectedDay || event.category_id !== selectedCategory) {
      return null;
    }
    var start = new Date(event.start);
    var end = new Date(event.end);
    if (end < new Date()) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      key: event.id,
      style: {
        padding: '0.5em'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        boxShadow: '0.5em 0.5em 0.75em rgba(0,0,0,0.2)',
        border: 'solid 1px  rgba(0,0,0,0.2)',
        padding: '1em',
        width: '86%',
        borderRadius: '0.5em',
        scrollbarColor: cell.text_color + ' ' + cell.text_color,
        scrollbarWidth: '0.5em'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: 8
      }
    }, /*#__PURE__*/_react.default.createElement("p", {
      style: {
        fontSize: cell.font_size_name / 2 / 2 + 'em',
        fontWeight: 'bold'
      }
    }, (start.getHours() - 1).toString().padStart(2, '0') + ':' + start.getMinutes().toString().padStart(2, '0') + ' - ' + (end.getHours() - 1).toString().toString().padStart(2, '0') + ':' + end.getMinutes().toString().padStart(2, '0')), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        fontSize: cell.font_size_name / 2 / 2 + 'em',
        fontWeight: 'bold'
      }
    }, (0, _utils.i18nData)(event, 'name', intl, defaultLanguage)), event.speaker && /*#__PURE__*/_react.default.createElement("p", {
      style: {
        marginTop: '0.3em',
        color: cell.text_color_event_details,
        fontSize: cell.font_size_details / 2 / 2 + 'em'
      }
    }, /*#__PURE__*/_react.default.createElement(SpeakerSVG, null), (0, _utils.i18nData)(event, 'speaker', intl, defaultLanguage)), event.location && /*#__PURE__*/_react.default.createElement("p", {
      style: {
        color: cell.text_color_event_details,
        fontSize: cell.font_size_details / 2 / 2 + 'em'
      }
    }, /*#__PURE__*/_react.default.createElement(LocationSVG, null), (0, _utils.i18nData)(event, 'location', intl, defaultLanguage)), event.language && /*#__PURE__*/_react.default.createElement("p", {
      style: {
        color: cell.text_color_event_details,
        fontSize: cell.font_size_details / 2 / 2 + 'em'
      }
    }, /*#__PURE__*/_react.default.createElement(LangSVG, null), (0, _utils.i18nData)(event, 'language', intl, defaultLanguage))), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: 2
      }
    }, (event.description || event.image_uri) && /*#__PURE__*/_react.default.createElement("span", {
      onClick: function onClick() {
        setCurrentEvent(event);
      },
      style: {
        boxShadow: '0.25em 0.25em 0.37em rgba(0,0,0,0.2)',
        border: 'solid 0.05em ' + cell.text_color_button_open,
        height: '1em',
        width: '1em',
        justifyContent: 'center',
        textAlign: 'center',
        borderRadius: '1em',
        position: 'absolute',
        marginTop: '1.5em',
        marginLeft: '2.5em',
        padding: '0.1em',
        color: cell.text_color_button_open,
        fontSize: '1em'
      }
    }, "+")))));
  }))))), /*#__PURE__*/_react.default.createElement(PopUpEvent, {
    currentEvent: curentEvent,
    setCurrentEvent: setCurrentEvent,
    cell: cell,
    intl: intl,
    defaultLanguage: defaultLanguage,
    uriTransformer: uriTransformer
  }));
}
function PopUpEvent(_ref12) {
  var currentEvent = _ref12.currentEvent,
    setCurrentEvent = _ref12.setCurrentEvent,
    cell = _ref12.cell,
    intl = _ref12.intl,
    defaultLanguage = _ref12.defaultLanguage,
    uriTransformer = _ref12.uriTransformer;
  if (!currentEvent) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick() {
      setCurrentEvent(null);
    },
    style: {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,0.6)',
      zIndex: '1000',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _defineProperty({
      boxShadow: '1em 1em 1em rgba(0,0,0,0.4)',
      width: '70%',
      height: 'auto',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '0.5em',
      backgroundColor: cell.background_color_pop_up,
      padding: '0.5em',
      overflow: 'scroll',
      border: 'solid 0.1em',
      borderColor: cell.backgroundColor
    }, "borderRadius", '0.5em')
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: 1
    }
  }, currentEvent.speaker && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '1em'
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: cell.text_color_event_details,
      fontSize: cell.font_size_details / 2 / 2 + 'em',
      fontWeight: 'normal'
    }
  }, /*#__PURE__*/_react.default.createElement(SpeakerSVG, null), " ", (0, _utils.i18nData)(currentEvent, 'speaker', intl, defaultLanguage))), currentEvent.location && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '1em'
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: cell.text_color_event_details,
      fontSize: cell.font_size_details / 2 / 2 + 'em',
      fontWeight: 'normal'
    }
  }, /*#__PURE__*/_react.default.createElement(LocationSVG, null), " ", (0, _utils.i18nData)(currentEvent, 'location', intl, defaultLanguage))), currentEvent.language && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '1em'
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: cell.text_color_event_details,
      fontSize: cell.font_size_details / 2 / 2 + 'em',
      fontWeight: 'normal'
    }
  }, /*#__PURE__*/_react.default.createElement(LangSVG, null), " ", (0, _utils.i18nData)(currentEvent, 'languague', intl, defaultLanguage)))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: 3
    }
  }, currentEvent.description && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (0, _utils.i18nData)(currentEvent, 'description', intl, defaultLanguage)
    },
    style: {
      color: cell.text_color_event_description,
      fontSize: cell.font_size_description / 2 / 2 + 'em',
      fontWeight: 'normal'
    }
  })), currentEvent.image_uri && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '2em',
      padding: '1em'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: uriTransformer((0, _utils.i18nData)(currentEvent, 'image_uri', intl, defaultLanguage)),
    style: {
      boxShadow: '0.5em 0.5em 0.5em rgba(0,0,0,0.4)',
      borderRadius: '0.5em',
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }
  })))));
}
function LangSVG() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "1em",
    viewBox: "0 0 13 13",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.3306 2.06543C10.604 2.33887 10.8501 2.63574 11.0688 2.95605C11.2798 3.27637 11.4595 3.61621 11.6079 3.97559C11.7642 4.33496 11.8853 4.70996 11.9712 5.10059C12.0493 5.49121 12.0884 5.89355 12.0884 6.30762C12.0884 7.13574 11.9321 7.91309 11.6196 8.63965C11.3071 9.37402 10.8774 10.0146 10.3306 10.5615C9.7915 11.1006 9.15479 11.5264 8.42041 11.8389C7.69385 12.1514 6.9165 12.3076 6.08838 12.3076C5.67432 12.3076 5.27197 12.2686 4.88135 12.1904C4.49072 12.1045 4.11572 11.9834 3.75635 11.8271C3.39697 11.6787 3.05713 11.499 2.73682 11.2881C2.4165 11.0693 2.11963 10.8232 1.84619 10.5498C1.57275 10.2764 1.32666 9.97949 1.10791 9.65918C0.896973 9.33887 0.713379 8.99902 0.557129 8.63965C0.408691 8.28027 0.291504 7.90527 0.205566 7.51465C0.127441 7.12402 0.0883789 6.72168 0.0883789 6.30762C0.0883789 5.47949 0.244629 4.70215 0.557129 3.97559C0.869629 3.24121 1.29541 2.60449 1.83447 2.06543C2.38135 1.51855 3.02197 1.08887 3.75635 0.776367C4.48291 0.463867 5.26025 0.307617 6.08838 0.307617C6.50244 0.307617 6.90479 0.34668 7.29541 0.424805C7.68604 0.510742 8.06104 0.631836 8.42041 0.788086C8.77979 0.936523 9.11963 1.11621 9.43994 1.32715C9.76025 1.5459 10.0571 1.79199 10.3306 2.06543ZM11.5845 6.56543H9.4751V6.57715C9.46729 6.9834 9.43604 7.38184 9.38135 7.77246C9.32666 8.15527 9.25635 8.51855 9.17041 8.8623H10.9634L10.9517 8.88574C11.1392 8.54199 11.2876 8.1748 11.397 7.78418C11.5063 7.39355 11.5688 6.9873 11.5845 6.56543ZM11.5845 6.07324V6.06152C11.5688 5.63965 11.5063 5.2334 11.397 4.84277C11.2876 4.44434 11.1392 4.07324 10.9517 3.72949H9.14697L9.13525 3.65918C9.23682 4.0498 9.31494 4.44824 9.36963 4.85449C9.43213 5.25293 9.46729 5.65918 9.4751 6.07324H11.5845ZM6.34619 8.8623H8.65479L8.64307 8.9209C8.74463 8.5459 8.82275 8.16309 8.87744 7.77246C8.93994 7.38184 8.9751 6.97949 8.98291 6.56543H6.34619V8.8623ZM6.34619 3.2373H8.479L8.46729 3.20215C8.4126 3.05371 8.354 2.91309 8.2915 2.78027C8.229 2.63965 8.1626 2.51074 8.09229 2.39355V2.37012C7.92822 2.01074 7.69385 1.69824 7.38916 1.43262C7.09229 1.15918 6.74463 0.967773 6.34619 0.858398V3.2373ZM6.34619 3.72949V6.07324H8.98291C8.9751 5.65137 8.93994 5.24512 8.87744 4.85449C8.82275 4.45605 8.74463 4.08105 8.64307 3.72949H6.34619ZM9.00635 3.2373H10.6587L10.647 3.22559C10.4751 2.96777 10.2837 2.72949 10.0728 2.51074C9.86182 2.28418 9.63135 2.08105 9.38135 1.90137C9.13135 1.71387 8.86572 1.5498 8.58447 1.40918C8.30322 1.26074 8.01025 1.13965 7.70557 1.0459C7.86963 1.20215 8.01807 1.37402 8.15088 1.56152C8.2915 1.74121 8.4165 1.93652 8.52588 2.14746L8.51416 2.1123C8.60791 2.28418 8.69385 2.46387 8.77197 2.65137C8.85791 2.83105 8.93604 3.02637 9.00635 3.2373ZM8.50244 9.35449H6.34619V11.792H6.36963C6.75244 11.6748 7.09619 11.4834 7.40088 11.2178C7.70557 10.9521 7.93604 10.6318 8.09229 10.2568L8.08057 10.292C8.15869 10.1514 8.23291 10.0029 8.30322 9.84668C8.37354 9.69043 8.43994 9.52637 8.50244 9.35449ZM7.75244 11.5576L7.7876 11.5459C8.38135 11.3506 8.92432 11.0654 9.4165 10.6904C9.90869 10.3154 10.3267 9.87012 10.6704 9.35449H9.01807L9.00635 9.40137C8.93604 9.59668 8.86182 9.78809 8.78369 9.97559C8.70557 10.1631 8.61963 10.335 8.52588 10.4912L8.51416 10.5146C8.4126 10.71 8.29541 10.8936 8.1626 11.0654C8.0376 11.2373 7.90088 11.4014 7.75244 11.5576ZM5.854 3.72949H3.56885L3.58057 3.6709C3.47119 4.05371 3.38525 4.44824 3.32275 4.85449C3.26025 5.25293 3.2251 5.65918 3.21729 6.07324H5.854V3.72949ZM3.67432 2.14746L3.68604 2.12402C3.7876 1.9209 3.90869 1.72949 4.04932 1.5498C4.18994 1.3623 4.34229 1.19043 4.50635 1.03418L4.47119 1.0459C4.1665 1.13965 3.87354 1.25684 3.59229 1.39746C3.31885 1.53809 3.05713 1.70215 2.80713 1.88965C2.55713 2.07715 2.32275 2.28418 2.104 2.51074C1.89307 2.7373 1.69775 2.97949 1.51807 3.2373H3.19385L3.21729 3.19043C3.27979 3.00293 3.3501 2.82324 3.42822 2.65137C3.50635 2.47168 3.58838 2.30371 3.67432 2.14746ZM5.854 9.35449H3.69775L3.72119 9.38965C3.77588 9.5459 3.83447 9.69824 3.89697 9.84668C3.96729 9.99512 4.0376 10.1318 4.10791 10.2568V10.2686C4.27197 10.6357 4.50244 10.9521 4.79932 11.2178C5.104 11.4834 5.45557 11.6748 5.854 11.792V9.35449ZM3.21729 6.56543V6.57715C3.2251 6.9834 3.25635 7.38184 3.31104 7.77246C3.37354 8.15527 3.45166 8.51855 3.54541 8.8623H5.854V6.56543H3.21729ZM2.7251 6.56543H0.592285V6.57715C0.60791 6.99902 0.67041 7.40137 0.779785 7.78418C0.88916 8.16699 1.03369 8.52637 1.21338 8.8623H3.0415L3.05322 8.93262C2.95166 8.55762 2.87354 8.1748 2.81885 7.78418C2.76416 7.38574 2.73291 6.97949 2.7251 6.56543ZM1.2251 3.72949L1.23682 3.70605C1.0415 4.05762 0.88916 4.43262 0.779785 4.83105C0.67041 5.22949 0.60791 5.64355 0.592285 6.07324H2.7251C2.73291 5.65137 2.76416 5.24512 2.81885 4.85449C2.87354 4.45605 2.95166 4.08105 3.05322 3.72949H1.2251ZM3.18213 9.35449H1.50635L1.51807 9.36621C1.68994 9.62402 1.88135 9.86621 2.09229 10.0928C2.30322 10.3115 2.53369 10.5146 2.78369 10.7021C3.03369 10.8896 3.29932 11.0576 3.58057 11.2061C3.854 11.3467 4.14697 11.4678 4.45947 11.5693C4.30322 11.4131 4.15869 11.249 4.02588 11.0771C3.90088 10.8975 3.78369 10.7021 3.67432 10.4912L3.68604 10.5264C3.59229 10.3545 3.50244 10.1709 3.4165 9.97559C3.33057 9.78027 3.25244 9.57324 3.18213 9.35449ZM3.72119 3.2373H5.854V0.858398H5.83057C5.44775 0.967773 5.104 1.15918 4.79932 1.43262C4.49463 1.69824 4.26416 2.01465 4.10791 2.38184L4.11963 2.3584C4.0415 2.49121 3.97119 2.63184 3.90869 2.78027C3.84619 2.9209 3.78369 3.07324 3.72119 3.2373Z",
    fill: "black"
  }));
}
function LocationSVG() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "1em",
    viewBox: "0 0 10 13",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.90088 0.307617C4.90869 0.307617 4.9126 0.307617 4.9126 0.307617C4.92041 0.307617 4.92822 0.307617 4.93604 0.307617C5.52197 0.307617 6.07275 0.416992 6.58838 0.635742C7.104 0.862305 7.55322 1.16699 7.93604 1.5498C8.32666 1.9248 8.63525 2.37012 8.86182 2.88574C9.08838 3.40137 9.20557 3.95215 9.21338 4.53809C9.21338 5.32715 8.98682 6.17871 8.53369 7.09277C8.08838 8.01465 7.59619 8.86621 7.05713 9.64746C6.51807 10.4287 6.02197 11.0811 5.56885 11.6045C5.12354 12.1201 4.90088 12.3779 4.90088 12.3779C4.90088 12.3779 4.67432 12.1201 4.22119 11.6045C3.77588 11.0811 3.28369 10.4287 2.74463 9.64746C2.20557 8.86621 1.70947 8.01465 1.25635 7.09277C0.811035 6.17871 0.588379 5.32715 0.588379 4.53809V4.52637C0.596191 3.94824 0.713379 3.40137 0.939941 2.88574C1.1665 2.37012 1.47119 1.9248 1.854 1.5498C2.24463 1.16699 2.69775 0.862305 3.21338 0.635742C3.729 0.416992 4.27979 0.307617 4.86572 0.307617C4.87354 0.307617 4.87744 0.307617 4.87744 0.307617C4.88525 0.307617 4.89307 0.307617 4.90088 0.307617ZM4.90088 6.03809V6.0498C4.90869 6.0498 4.9126 6.0498 4.9126 6.0498C4.92041 6.0498 4.92822 6.0498 4.93604 6.0498C5.3501 6.0498 5.70166 5.90137 5.99072 5.60449C6.2876 5.30762 6.43604 4.95215 6.43604 4.53809C6.43604 4.11621 6.2876 3.76074 5.99072 3.47168C5.70166 3.1748 5.3501 3.02637 4.93604 3.02637C4.51416 3.02637 4.15479 3.1748 3.85791 3.47168C3.56885 3.76074 3.42432 4.11621 3.42432 4.53809C3.42432 4.94434 3.56494 5.2959 3.84619 5.59277C4.13525 5.88184 4.48682 6.03027 4.90088 6.03809Z",
    fill: "black"
  }));
}
function SpeakerSVG() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.81494 8.33496C7.52588 8.38965 8.18604 8.51465 8.79541 8.70996C9.4126 8.90527 9.94775 9.15137 10.4009 9.44824C10.854 9.74512 11.2095 10.0811 11.4673 10.4561C11.7251 10.8389 11.854 11.2412 11.854 11.6631H0.0883789C0.0883789 11.2412 0.217285 10.8389 0.475098 10.4561C0.73291 10.0811 1.08838 9.74512 1.5415 9.44824C1.99463 9.15137 2.52588 8.90527 3.13525 8.70996C3.75244 8.51465 4.4165 8.38965 5.12744 8.33496V7.64355L5.11572 7.63184C4.61572 7.2959 4.21338 6.8584 3.90869 6.31934C3.604 5.77246 3.45166 5.1748 3.45166 4.52637C3.45166 4.00293 3.46338 3.51074 3.48682 3.0498C3.51025 2.58887 3.6001 2.19043 3.75635 1.85449C3.92041 1.51074 4.17041 1.2373 4.50635 1.03418C4.8501 0.838867 5.33838 0.741211 5.97119 0.741211C6.59619 0.741211 7.08057 0.838867 7.42432 1.03418C7.76807 1.2373 8.01807 1.51074 8.17432 1.85449C8.33057 2.19043 8.42432 2.58887 8.45557 3.0498C8.479 3.51074 8.49072 4.00293 8.49072 4.52637C8.49072 5.1748 8.33838 5.77246 8.03369 6.31934C7.729 6.8584 7.32275 7.2998 6.81494 7.64355V8.33496Z",
    fill: "black"
  }));
}